import { trimChar } from 'src/utils/trimChar';

export function replaceSpecialSymbols(str: string) {
  // Replace runs of special chars with "-", then trim leading/trailing "-".
  return trimChar(str.replace(/[^a-zA-Z0-9]+/g, '-'), '-');
}
